import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import ReactDataGrid from 'react-data-grid';
import { formatDate } from '../../Util';
import 'bootstrap/dist/css/bootstrap.css';

import Lock from '../Icons/Lock.svg';
import Public from '../Icons/Public.svg';

class ProjectsBoard extends Component {

	constructor(props,context) {
	    super(props,context);
	    this._columns = [
	      {
	        key: 'project_id',
	        name: 'ID',
	        resizable: true,
	        locked: true,
	        formatter: this.makeIdClickable
	      },
	      {
	        key: 'title',
	        name: 'Title',
	        width: 180,
	        resizable: true,
	        sortable: true
	      },
	      {
	        key: 'creator_name',
	        name: 'Creator',
	        width: 160,
	        resizable: true,
	        sortable: true
	      },
	      {
	        key: 'creator_email',
	        name: 'Creator Mail',
	        width: 200,
	        resizable: true,
	        sortable: true
	      },
	      {
	        key: 'project_created_at',
	        name: 'Creation date',
	        width: 100,
	        resizable: true,
	        sortable: true,
	        formatter: this.formatBoardDate
	      },
	      {
	        key: 'project_end_at',
	        name: 'Ending date',
	        width: 90,
	        resizable: true,
	        sortable: true,
	        formatter: this.formatBoardDate
	      },
	      {
	        key: 'privacy',
	        name: 'Privacy',
	        width: 60,
	        resizable: true,
	        sortable: true,
	        formatter: this.formatPrivacy
	      },
	      {
	        key: 'project_achieved_at',
	        name: 'Status',
	        width: 120,
	        resizable: true,
	        sortable: true,
	        formatter: this.formatStatus
	      },
	      {
	        key: 'current_amount',
	        name: 'Current amount',
	        width: 120,
	        resizable: true,
	        sortable: true,
	        formatter: this.formatAmount
	      }
	    ];
	    let originalRows = this.props.items;
	    let rows = originalRows.slice(0);
	    this.state = { originalRows, rows };
	    this.rowGetter = this.rowGetter.bind(this);
	    this.handleGridSort = this.handleGridSort.bind(this);
	    this.formatBoardDate = this.formatBoardDate.bind(this);
	    this.formatStatus = this.formatStatus.bind(this);
	    this.makeIdClickable = this.makeIdClickable.bind(this);
	    this.formatPrivacy = this.formatPrivacy.bind(this);
	    this.formatAmount = this.formatAmount.bind(this);
	}

	formatBoardDate(value){
		return formatDate(value.value);
	}

	formatStatus(value){
		if(value.value !== null){
			return <div><div className='dot grey'></div>{formatDate(value.value)}</div>;
		}else{
			return <div><div className='dot green'></div>Running</div>;
		}
	}

	formatAmount(value){
		if(value.value === null){
			return "0€";
		}else{
			return value.value + "€";
		}
	}

	formatPrivacy(value){
		if(value.value === 1){
			return <img src={Lock} alt="Private project" title="Private project" className="lock" />
		}else{
			return <img src={Public} alt="Public project" title="Public project" className="public" />
		}
	}

	makeIdClickable(value){
		return <Link to={'/projects/'+value.value} key={value.value}>{value.value}</Link>
	}

	handleGridSort(sortColumn, sortDirection){
	    const comparer = (a, b) => {
	      if (sortDirection === 'ASC') {
	        return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
	      } else if (sortDirection === 'DESC') {
	        return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
	      }
	    };

	    const rows = sortDirection === 'NONE' ? this.state.originalRows.slice(0) : this.state.rows.sort(comparer);

	    this.setState({ rows });
	}

	rowGetter(i){
	    return this.state.rows[i];
	}

	render() {
		return (
			<div className="adminBoard">
				<ReactDataGrid
			        onGridSort={this.handleGridSort}
			        columns={this._columns}
			        rowGetter={this.rowGetter}
			        rowsCount={this.state.rows.length}
			        minHeight={400} />
			</div>
		);
	}
}

export default ProjectsBoard;



// WEBPACK FOOTER //
// ./src/components/Admin/ProjectsBoard.js